<template>
  <div class="staff-review-area">
    <HeadingThree>スタッフレビュー</HeadingThree>
    <div
      v-for="review in staffReviews"
      :key="review.id"
      class="staff-review-item"
    >
      <div class="staff-review-item__header">
        <img
          :src="review.iconImageUrl"
          :alt="review.staffName"
          class="staff-review-item__icon"
        />
        <div class="staff-review-item__header-info">
          <h4 class="staff-review-item__title">
            {{ review.title }}
          </h4>
          <span class="staff-review-item__name">
            スタッフ {{ review.staffName }}
          </span>
        </div>
      </div>
      <p class="staff-review-item__description">
        {{ review.description }}
      </p>
      <div v-if="review.linkUrl" class="staff-review-item__link-wrapper">
        <ButtonSecondary
          text="レビューを詳しく読む"
          class="staff-review-item__link"
          @click-secondary-button="openLink(review.linkUrl)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import HeadingThree from '../../atoms/headlines/HeadingThree.vue'
import ButtonSecondary from '../buttons/ButtonSecondary.vue'
import { sanitizeUrl } from '../../../utils/UrlSanitizer.js'

export default {
  name: 'StaffReviewArea',
  components: {
    HeadingThree,
    ButtonSecondary
  },
  props: {
    staffReviews: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    openLink(url) {
      window.open(sanitizeUrl(url), '_blank', 'noopener,noreferrer')
    }
  }
}
</script>

<style lang="scss" scoped>
.staff-review-area {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.staff-review-item {
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  background: $primary-lighten;
}

.staff-review-item__header {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.staff-review-item__icon {
  width: 56px;
  height: 56px;
  border-radius: 56px;
  object-fit: cover;
}

.staff-review-item__header-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  justify-content: center;
}

.staff-review-item__title {
  @extend %subhead;
  font-weight: normal;
  color: $brown-1;
}

.staff-review-item__name {
  @extend %minimal;
  color: $brown-2;
}

.staff-review-item__description {
  @extend %caption;
  color: $brown-1;
  white-space: pre-wrap;
}

.staff-review-item__link-wrapper {
  width: 100%;
}

.staff-review-item__link {
  width: 100%;
  font-size: 1.2rem;
  height: 36px;
  padding: 0 16px;
  line-height: 1.6;
}
</style>
